export const useLoadingStore = definePiniaStore('loadingState', () => {
    const loading = ref(false)
    const progress = ref(0)
    const loadingText = ref('')
    const isInitialLoad = ref(true)
    
    // Track different loading stages
    const stages = ref({
        assets: 0,
        scripts: 0,
        authentication: 0,
        appInit: 0
    })
    
    const setLoading = (isLoading: boolean, text?: string) => {
        loading.value = isLoading
        if (text) loadingText.value = text
        if (!isLoading) {
            progress.value = 100
            setTimeout(() => {
                progress.value = 0
                isInitialLoad.value = false
            }, 500)
        }
    }
    
    const setProgress = (value: number, text?: string) => {
        progress.value = Math.min(100, Math.max(0, value))
        if (text) loadingText.value = text
    }
    
    const updateStage = (stage: keyof typeof stages.value, value: number) => {
        stages.value[stage] = value
        // Calculate overall progress based on weighted stages
        const overallProgress = (
            stages.value.assets * 0.4 + 
            stages.value.scripts * 0.3 + 
            stages.value.authentication * 0.2 + 
            stages.value.appInit * 0.1
        )
        setProgress(overallProgress)
    }
    
    return {
        loading,
        progress,
        loadingText,
        isInitialLoad,
        stages,
        setLoading,
        setProgress,
        updateStage
    }
})